<template>
    <div id="app">
        <LangSwitchCom></LangSwitchCom>
        <NavbarCom></NavbarCom>
        <NoticeCom></NoticeCom>
        <OverlayMsgCom
            :show="!appConfig.APP_OPEN_SHOP"
        ></OverlayMsgCom>
        <router-view class="content" ref="app"></router-view>
        <footerCom v-if="showFooter()"></footerCom>
        <TabbarCom></TabbarCom>
        <!---------------------------------------------------------------------------------------------------------------------------------------------
         * Product Preview Com
        ---------------------------------------------------------------------------------------------------------------------------------------------->
        <ProductPreviewCom>
        </ProductPreviewCom>
    </div>
</template>

<script setup>
import { useStore } from "vuex"
import router from "./router";
import ProductPreviewCom from "./components/ProductCom/ProductPreviewCom.vue"
import TabbarCom from "@/components/TabbarCom/TabbarCom.vue"
import LangSwitchCom from "@/components/LangSwitchCom/LangSwitchCom.vue"
import NavbarCom from "./components/NavbarCom/NavbarCom.vue";
import NoticeCom from "./components/NoticeCom/NoticeCom.vue";
import OverlayMsgCom from "./components/OverlayNotiCom/OverlayMsgCom.vue";
import { ref, onMounted } from "vue"
import forceMobileMode from "./utils/forceMobileMode";
import i18n from "./i18n"
import apiConfig from "./config/api.config";
import { appConfig } from "./config/app.config";
import footerCom from "./components/footerCom/footerCom.vue";
import { logCartService } from "./services/h5/h5CustomerService";
import { colog } from "colog-node";

// MARK - Props
// ************************************************************************
const { t } = i18n.global
const store = useStore()


// MARK - LIFE CYCLE
// ************************************************************************
onMounted(() => {
    forceMobileMode()
    document.title = t('app.title')

    /*禁止ios缩放，双击和双指*/
    disableH5Zoom()

    // Umami
    loadUmami()

    // 定时抓取用户信息
    const intervalId = setInterval(function() {
        store.dispatch("FetchUserInfo")
    }, 5000); // 每3000毫秒 执行一次

    // 定时发送购物车log
    const logCartIntervalId = setInterval(function() {
        if (store.getters.getToken.length > 0) {
            let params = {
                token: store.getters.getToken,
                data: store.getters.getCartAll
            }
            logCartService(params).then((res) => {
            }).catch((err) => {
            })
        }
    }, 5000)
})

// MARK - Methods
// ************************************************************************
/**
 * @func 是否显示 footer
 */
const showFooter = () => {
    // 定义不需要显示 footer 的路由
    const noFooterRoutes = ["/category"];
    return !noFooterRoutes.includes(router.currentRoute.value.path);
}

const loadUmami = () => {
    // 动态加载 Umami 追踪脚本
    const script = document.createElement('script');
    let umamiScript = apiConfig.UMAMI_SCRIPT_SRC
    let umamiID = apiConfig.UMAMI_WEBSITE_ID
    script.src = umamiScript
    script.async = true;
    script.defer = true;
    script.setAttribute('data-website-id', umamiID); // 替换为你的 Umami 网站 ID
    document.head.appendChild(script);
}
/**
 * Function to disable zooming on touch events.
 *
 * @return {void}
 */
const disableH5Zoom = () => {
    window.onload = function() {
        document.addEventListener("touchstart", function(event) {
            if (event.touches.length > 1) {
                event.preventDefault();
            }
        });
        var lastTouchEnd = 0;
        document.addEventListener(
            "touchend",
            function(event) {
                var now = new Date().getTime();
                if (now - lastTouchEnd <= 300) {
                    event.preventDefault();
                }
                lastTouchEnd = now;
            },
            false
        );
        document.addEventListener("gesturestart", function(event) {
            event.preventDefault();
        });
    }
}


</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

html,
body,
ul,
li,
div,
h1 {
    padding: 0;
    margin: 0;
}


/* 禁止ios缩放 */
@media screen and (-webkit-min-device-pixel-ratio:0) {
    select,
    textarea,
    input {
        font-size: 16px;
    }
}
@media screen and (-webkit-min-device-pixel-ratio:0) {
    select:focus,
    textarea:focus,
    input:focus {
        font-size: 16px;
    }
}
</style>
